import {
  updateDoc,
  getFirestore,
  doc,
  getDoc,
  addDoc,
  collection,
  getDocs,
  deleteDoc
} from "firebase/firestore";
import { app } from "../../credenciales";

const db = getFirestore(app);

export const deleteActivityDate = async (activity, selectedDate) => {
  try {
    const actividadesRef = doc(db, "actividades", activity.id);
    const actividadSnap = await getDoc(actividadesRef);

    if (actividadSnap.exists()) {
      const actividadData = actividadSnap.data();
      const nuevasFechas = actividadData.fechas.filter((f) => f.fecha !== selectedDate);

      await updateDoc(actividadesRef, { fechas: nuevasFechas });

    } else {
      console.log("No existe la actividad");
    }
  } catch (error) {
    console.log(error);
  }
}

export const addActivity = async (activityName, isSingleClass, fechasActividad, hour) => {
  try {
    await addDoc(collection(db, "actividades"), {
      nombre: activityName,
      isSingleClass,
      fechas: fechasActividad,
      hora: hour
    });
  } catch (error) {
    console.log(error);
  }
}

export const getActivityData = async (id) => {
  try {
    const docRef = doc(db, "actividades", id);
    const docSnap = await getDoc(docRef);
    return docSnap;
  } catch (error) {
    console.log(error);
  }
}

export const updateActivity = async (nombre, hora, isSingleClass, fechas, id) => {
  try {
    const docRef = doc(db, "actividades", id);
    await updateDoc(docRef, {
      nombre: nombre,
      hora: hora,
      isSingleClass: isSingleClass,
      fechas: fechas
    });
  } catch (error) {
    console.log(error);
  }
}

export const getActivities = async () => {
  try {
    const actividadesCollection = collection(db, "actividades");
    const responseDb = await getDocs(actividadesCollection);
    const actividadesList = responseDb.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    return actividadesList;
  } catch (error) {
    console.log(error);
  }
}

export const deleteActivity = async (id) => {
  try {
    await deleteDoc(doc(db, "actividades", id));
  } catch (error) {
    console.log(error);
  }
}

export const updateActivityUsersDates = async (updatedDates, id) => {
  try {
    const docRef = doc(db, "actividades", id);
    await updateDoc(docRef, {fechas: updatedDates});
  } catch (error) {
    console.log(error);
  }
}